export default __webpack_public_path__ + "static/media/default-error-icon.db2ec1f0.png";